import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import companyInfoLogo from "../../assets/companyInfoLogo.png"
import bannerImage from '../../assets/bannerImage01.jpeg';
import logo from '../../assets/logo.png';
// import background from '../../assets/companyInfoBg.png';
import styles from './CompanyInfo.module.scss';
function CompanyInfo() {
  return (
    <div>
      <Header />
      <div className={styles.contentWrap}>
        <img src={companyInfoLogo} alt="Company Info Logo" />
        <p>
          글로우라인은 <span className={styles.themeColor}>비대면 한방 진료의<br />
          새로운 기준을 제시</span><span className={styles.inlineText}>합니다!</span>
        </p>
        <p>
          병원에 가지 않아도, 글로우라인을 통해 언제 어디서나
          <br />
          편리하게 한방진료를 받을 수 있습니다.
          <br />
          신속하고 안전한 의료 서비스를 경험해보세요.
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default CompanyInfo;
